import "@styles/layout.css";
import { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { AuthContext } from "@contexts/AuthContext";

import Navbar from "@common-components/Navbar/Navbar";
import Footer from "@common-components/Footer/Footer";
import NotifyPop from "@common-components/NotifyPop/NotifyPop";

const AuthRequiredPageLayout = () => {
  const { currentUser } = useContext(AuthContext);

  return !currentUser ? (
    <Navigate to={"/home/login"} />
  ) : (
    currentUser && (
      <div className="Layout__container">
        <Navbar />
        <Outlet />
        <Footer />
        <NotifyPop />
      </div>
    )
  );
};

export default AuthRequiredPageLayout;
